// Find shortcuts belong to the last search the user interacted with. Keep them
// outside editor keymaps so Ctrl+G also works while a note editor has focus.
const searches = new Set();
let active = null;
let listening = false;

function handleKey(event) {
  if (!(event.ctrlKey || event.metaKey) || event.altKey || event.isComposing) return;
  const key = event.key.toLowerCase();
  if (!['f', 'g'].includes(key)) return;
  const modalOpen = [...document.querySelectorAll('.modal.active, .notes-delete-modal.active, [aria-modal="true"]')]
    .some(modal => !modal.closest('[inert]') && modal.getClientRects().length && modal.getAttribute('aria-hidden') !== 'true' && getComputedStyle(modal).visibility !== 'hidden');
  if (modalOpen) return;
  const available = [...searches].filter(search => search.available());
  const within = available.find(search => search.contains(event.target));
  const search = key === 'f' ? (within || available.find(search => search.primary))
    : (within?.hasQuery() ? within : available.includes(active) && active.hasQuery() ? active : available.find(search => search.hasQuery()));
  if (!search) return;
  event.preventDefault();
  event.stopImmediatePropagation();
  active = search;
  if (key === 'f') search.focus();
  else search.next(event.shiftKey ? -1 : 1);
}

export function registerSearchNavigation(search) {
  searches.add(search);
  if (!listening) {
    document.addEventListener('keydown', handleKey, true);
    listening = true;
  }
  return {
    activate: () => { active = search; },
    dispose: () => {
      searches.delete(search);
      if (active === search) active = null;
      if (!searches.size) {
        document.removeEventListener('keydown', handleKey, true);
        listening = false;
      }
    },
  };
}
